export const spacingUnitSizeInPx = 8;
export const horizontalPaddingInSu = 4.5; // in spacing units
export const horizontalPaddingInPx = 4.5 * spacingUnitSizeInPx;
export const maxPageWidthInPxNumber = 1376;
export const maxPageWidthInPx = `${maxPageWidthInPxNumber}px`;
export const maxPageWidthInPxIncludingPadding = `calc(${maxPageWidthInPx} + ${horizontalPaddingInPx * 2}px)`;
export const defaultAutosizePadding = 4;
export const defaultTooltipShowDelay = 600;
